import { render, staticRenderFns } from "./TokenPasswordChangeView.vue?vue&type=template&id=60e013e8&scoped=true"
import script from "./TokenPasswordChangeView.vue?vue&type=script&lang=ts"
export * from "./TokenPasswordChangeView.vue?vue&type=script&lang=ts"
import style0 from "./TokenPasswordChangeView.vue?vue&type=style&index=0&id=60e013e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e013e8",
  null
  
)

export default component.exports